module.exports = __webpack_public_path__ + "img/company.b4d7745f.png";